import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
    selectedReference: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedReference(state, payload) {
      state.selectedReference = payload
    }

  },
  actions: {
    async loadAllBySourceID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("sources/emissionsFactor/bySourceID", {
        params: {
          id: id
        }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("sources/emissionsFactor/byID", {
        params: {
          id: id
        }
      });
      commit("setSelectedReference", list.data[0]);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("sources/emissionsFactor", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySourceID", payload.sources_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`sources/emissionsFactor`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllBySourceID", payload.sources_id);
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedReference(state) {
      return state.selectedReference
    }
  }
}
